import React from 'react'
import './AdminDashboard.css';
import { useNavigate } from 'react-router-dom';
const AdminDashboard = () => {
    const navigate = useNavigate();
    return (
        <div className="admin-dashboard">
            <div className="admin-header">
                <h2>Admin Dashboard</h2>
                <p>Welcome back, Admin 👑</p>
            </div>

            <div className="admin-stats">
                <div className="stat-card">
                    <h3>Users</h3>
                    <p>1,245</p>
                </div>

                {/* <div className="stat-card">
                    <h3>Active Trials</h3>
                    <p>32</p>
                </div>

                <div className="stat-card">
                    <h3>Pending Requests</h3>
                    <p>18</p>
                </div>

                <div className="stat-card">
                    <h3>System Status</h3>
                    <p className="status-active">Active</p>
                </div> */}
            </div>

            <div className="admin-grid">
                <div className="admin-box">
                    <h3>User Management</h3>
                    <p>Manage users, roles, and access.</p>
                    <button className="admin-btn" onClick={() => navigate('/userManagement')}>Open</button>
                </div>

            </div>
        </div>
    )
}
export default AdminDashboard;